<template>
  <div
    class="flex align-center"
    @click.prevent="toggleChecked">
    <label v-if="label" class="font-label mr-8">{{ label }}</label>

    <div
      class="checkbox">
      <div
        class="checkbox__checkmark"
        :class="{
          'checkbox__checkmark--checked': checked,
          'checkbox__checkmark--disabled': disabled,
        }" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  data() {
    return {
    };
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    toggleChecked() {
      if(!this.disabled) {
        this.$emit("input", this.value, !this.checked);
      }
    }
  }
}
</script>

<style lang="scss">
.checkbox {
  position: relative;
  height: 14px;
  width: 14px;

  cursor: pointer;

  &__checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 14px;
    width: 14px;

    border: $px1 solid $grey-8;
    border-radius: $px2;

    background-color: $white;

    &:hover {
      border-color: $grey-7;
    }

    &:after {
      content: "";
      position: absolute;
      display: none;
    }

    &--checked {
      border-color: $blue-6;

      &:hover {
        border-color: $blue-5;
      }

      &:after {
        display: block;
        left: 50%;
        top: 50%;
        width: $px8;
        height: $px8;

        border: 0;
        border-radius: $px1;

        background-color: $blue-5;

        transform: translate(-50%, -50%);
      }
    }

    &--disabled {
      border-color: $grey-8;

      background-color: $grey-9;

      &:hover {
        border-color: $grey-8;

        background-color: $grey-9;
      }

      &:after {
        background-color: $grey-7;
      }
    }
  }
}
</style>
